export default __webpack_public_path__ + "static/media/register-screen.17516193.svg";